export default __webpack_public_path__ + "static/media/logo_sq.33ac52b0.png";